const OUTCOME_CLEAR_ERROR = 'bfb/PROJECT_SDG/OUTCOME_CLEAR_ERROR';
const OUTCOMES_LIST = 'bfb/PROJECT_SDG/OUTCOMES_LIST';
const OUTCOMES_LIST_SUCCEEDED = 'bfb/PROJECT_SDG/OUTCOMES_LIST_SUCCEEDED';
const OUTCOMES_LIST_FAILED = 'bfb/PROJECT_SDG/OUTCOMES_LIST_FAILED';
const OUTCOME_CREATE = 'bfb/PROJECT_SDG/OUTCOME_CREATE';
const OUTCOME_CREATE_SUCCEEDED = 'bfb/PROJECT_SDG/OUTCOME_CREATE_SUCCEEDED';
const OUTCOME_CREATE_FAILED = 'bfb/PROJECT_SDG/OUTCOME_CREATE_FAILED';
const OUTCOME_DELETE = 'bfb/PROJECT_SDG/OUTCOME_DELETE';
const OUTCOME_DELETE_SUCCEEDED = 'bfb/PROJECT_SDG/OUTCOME_DELETE_SUCCEEDED';
const OUTCOME_DELETE_FAILED = 'bfb/PROJECT_SDG/OUTCOME_DELETE_FAILED';
const OUTCOME_FETCH = 'bfb/PROJECT_SDG/OUTCOME_FETCH';
const OUTCOME_FETCH_SUCCEEDED = 'bfb/PROJECT_SDG/OUTCOME_FETCH_SUCCEEDED';
const OUTCOME_FETCH_FAILED = 'bfb/PROJECT_SDG/OUTCOME_FETCH_FAILED';
const OUTCOME_UPDATE = 'bfb/PROJECT_SDG/OUTCOME_UPDATE';
const OUTCOME_UPDATE_SUCCEEDED = 'bfb/PROJECT_SDG/OUTCOME_UPDATE_SUCCEEDED';
const OUTCOME_UPDATE_FAILED = 'bfb/PROJECT_SDG/OUTCOME_UPDATE_FAILED';

export default {
  OUTCOMES_LIST,
  OUTCOMES_LIST_SUCCEEDED,
  OUTCOMES_LIST_FAILED,
  OUTCOME_CLEAR_ERROR,
  OUTCOME_CREATE,
  OUTCOME_CREATE_SUCCEEDED,
  OUTCOME_CREATE_FAILED,
  OUTCOME_DELETE,
  OUTCOME_DELETE_SUCCEEDED,
  OUTCOME_DELETE_FAILED,
  OUTCOME_FETCH,
  OUTCOME_FETCH_SUCCEEDED,
  OUTCOME_FETCH_FAILED,
  OUTCOME_UPDATE,
  OUTCOME_UPDATE_SUCCEEDED,
  OUTCOME_UPDATE_FAILED,
};
